// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2JPMr","left":"StickyBox_left__1o6uJ","right":"StickyBox_right__6w8k7"};